module.exports = __webpack_public_path__ + "html/battery-health-form.template.html";